import { Badge, Button, Callout, FileCard, Upload } from '@dev-spendesk/grapes';
import { Trans } from 'react-i18next';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

type Props = {
  error?: string;
  file: File | undefined;
  setFile: (file: File | undefined) => void;
};

const csvTemplate =
  'data:application/octet-stream;base64,bmFtZSxsZWdhbF9uYW1lLGJhbmtfY291bnRyeSxhY2NvdW50X3BheWFibGVfZ2VuZXJhbF9jb2Rl';

export const BulkImportSupplierAccountsForm = ({
  error,
  file,
  setFile,
}: Props) => {
  const { t } = useTranslation('global');

  return (
    <div className="flex flex-col gap-24">
      <div>
        <div className="mb-16 flex gap-16 text-left text-content-primary title-m">
          <Badge variant="primary">1</Badge>
          {t('setupHub.supplierAccounts.import.downloadTemplateStep')}
        </div>
        <Button
          className="ml-32 self-start"
          iconName="arrow-down-tray"
          component="a"
          href={csvTemplate}
          download="template.csv"
          text={t('setupHub.supplierAccounts.import.downloadTemplateButton')}
          variant="secondaryNeutral"
        />
      </div>
      <div>
        <div className="mb-16 flex gap-16 text-left text-content-primary title-m">
          <Badge variant="primary">2</Badge>
          {t('setupHub.supplierAccounts.import.uploadTemplateStep')}
        </div>
        <div className="flex flex-col gap-8">
          {!file ? (
            <Upload
              accept=".csv"
              activeDragContent={
                <>{t('forms.uploadFiles.activeDragContent')}</>
              }
              content={
                <Trans i18nKey="forms.uploadFiles.content">
                  <br />-
                  <span className="text-content-secondary-bg-primary underline title-m">
                    -
                  </span>
                </Trans>
              }
              onUpload={(files) => setFile(files[0])}
            />
          ) : (
            <FileCard title={file.name} onDelete={() => setFile(undefined)} />
          )}
          {error && <Callout title={error} variant="alert" />}
        </div>
      </div>
    </div>
  );
};
